.button {
  width: 180px;
}

.communicationButton {
  position: relative;
}

.communicationButtonContent {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: relative;
  line-height: 1;
  padding-top: 10px;
  min-height: 24px;
}

.totalBadgeCorner {
  position: absolute;
  top: -7.5px;
  right: -3px;
}

.totalBadgeNeutral :global(.sash-Badge) {
  min-width: 24px;
  height: 18px;
  padding: 0 6px;
  font-size: 0.7rem;
  line-height: 1;
  background-color: #ffffff;
  color: #16202a;
  border: 1px solid #b8c4d0;
}

.totalBadgeUnread :global(.sash-Badge) {
  min-width: 24px;
  height: 18px;
  padding: 0 6px;
  font-size: 0.7rem;
  line-height: 1;
  background-color: #f5c451;
  color: #2a1a00;
  border: 1px solid #8a6500;
}
